import { SearchResponse } from '@/models/Search';
import { Product } from '@/models/Product';
import { Category } from '@/models/CategoryDetail';
import { SearchBootResponse, SearchSuggestResponse } from '@/models/SearchSuggest';
import { getSearchOrigin } from './searchOrigin';

function emptySuggest(q = ''): SearchSuggestResponse {
  return {
    q,
    corrected: null,
    queries: [],
    categories: [],
    products: [],
    featured: null,
  };
}

export async function fetchSearchBoot(signal?: AbortSignal): Promise<SearchBootResponse> {
  const origin = getSearchOrigin();
  const res = await fetch(`${origin}/s/boot`, {
    signal,
    headers: { Accept: 'application/json' },
  });
  if (!res.ok) return { popularQueries: [], featured: [] };
  const data = (await res.json()) as SearchBootResponse;
  return {
    popularQueries: Array.isArray(data.popularQueries) ? data.popularQueries : [],
    featured: Array.isArray(data.featured) ? data.featured : [],
  };
}

export async function fetchSearchSuggest(
  query: string,
  signal?: AbortSignal,
  limit = 6,
): Promise<SearchSuggestResponse> {
  const q = query.trim();
  if (!q) return emptySuggest();
  const origin = getSearchOrigin();
  const res = await fetch(`${origin}/s/q?q=${encodeURIComponent(q)}&limit=${limit}`, {
    signal,
    headers: { Accept: 'application/json' },
  });
  if (!res.ok) return emptySuggest(q);
  const data = (await res.json()) as SearchSuggestResponse;
  return {
    q: data.q || q,
    corrected: data.corrected || null,
    queries: data.queries || [],
    categories: data.categories || [],
    products: data.products || [],
    featured: data.featured || null,
  };
}

export function mapSearchSuggestToPage(data: SearchSuggestResponse): SearchResponse {
  const categories: Category[] = (data.categories || []).map((c) => ({
    id: c.id,
    title: c.title,
    url: c.url,
    imageUrl: c.imageUrl || '',
  }));
  const products: Product[] = (data.products || []).map((p) => ({
    id: p.id,
    inStock: 1,
    code: '',
    title: p.title,
    titleWD: p.slug,
    imageUrl: p.imageUrl || '',
    url: p.url,
    price: p.price,
    priceBeforeDiscount: p.priceBeforeDiscount,
    images: p.imageUrl ? [{ imageUrl: p.imageUrl, alt: p.title }] : [],
    isExtra: false,
    categories: p.categories,
  }));
  return { categories, products };
}
